<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">FOB Invoice Price</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <section class="content-container">
      <app-data-form
        [dataFields]="fobTable"
        [dataName]="'fobTable'"
        [columns]="1"
        (updateFields_child)="handleUpdate($event)"
      />
      <div class="mt-4 flex w-full flex-col gap-1 sm:w-fit sm:flex-row">
        <button
          class="shorter-btn misc-btn"
          (click)="updateFOB()"
          [disabled]="saving"
        >
          <fa-icon [icon]="faSave" class="mr-1" />Update
        </button>
        <button
          class="shorter-btn clear-btn"
          (click)="clearFOB()"
          [disabled]="saving"
        >
          <fa-icon [icon]="faTrash" class="mr-1" />Clear
        </button>
      </div>
    </section>
  </div>
  <div class="content-container" *ngIf="loadedInvoiceNo">
    <p *ngIf="loading" class="mb-3" role="status">Loading invoice details…</p>
    <p *ngIf="!loading && !fob_entries.length" class="mb-3" role="status">
      No vehicle records found for this invoice.
    </p>
    <div class="w-full overflow-x-auto">
      <app-data-table
        class="block min-w-[42rem]"
        [tableHeaders]="fob_headers"
        [tableEntries]="fob_entries"
        (edit)="editEntry($event)"
      />
    </div>
  </div>
</section>
